import { useEffect, useRef, useState } from "react";
import { File } from "react-feather";
import { FaFileInvoice } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Card, CardContent } from "semantic-ui-react";
import {
  saveDocumentManagement,
  updateDocumentManagement
} from "../../../api/documentManagementApi";
import {
  addAndUpload,
  deleteDocumentList,
  updateAndUpload
} from "../../../api/documentUpload";
import { searchInvoiceJobs } from "../../../api/finance/transporter-invoice";
import { vehicleAssignmentSearch } from "../../../api/jobApi";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import { FORMS, MODULES } from "../../../const";
import {
  formatToDateOnlyFromJsonDate
} from "../../../dateConfig";
import useFirstAndLastAuthorizedTab from "../../../hooks/useFirstAndLastAuthorizedTab";
import useNextAndPreviousAuthority from "../../../hooks/useNextAndPreviousAuthority";
import useUserCompany from "../../../hooks/useUserCompany";
import { errorActions } from "../../../store/error-slice";
import DocumentUpload from "../../DocumentUpload";
import Button from "../../input/Button";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import SearchDropdown from "../../input/SearchDropdown";
import Tab from "../../Tab";
import { supplierInvoiceValidation } from "../../validations/SupplierInvoice";

const TransporterInvoiceAdd = ({
  editMode,
  tdhId,
  currentValues,
  documents,
  handleDrawerClose,
}) => {
  const [tab, setTab] = useState(1);
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [tdhTransporter, setTdhTransporter] = useState("");
  const [tdhActionDate, setTdhActionDate] = useState("");
  const [tdhNextDate, setTdhNextDate] = useState("");
  const [tdhRefId, setTdhRefId] = useState("");
  const [tdhStatus, setTdhStatus] = useState(2);
  const [tdhCompany, setTdhCompany] = useState("");
  const [tdhCategory, setTdhCategory] = useState("");
  const [tdhActive, setTdhActive] = useState("");
  const [tdhInspectionType, setTdhInspectionType] = useState("");
  const [dateType, setDateType] = useState(1);
  const [dateTypeOpt, setDateTypeOpt] = useState([]);
  const docRef = useRef();
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [statusTypeOptions, setStatusTypeOptions] = useState([]);
  const [activeTypeOptions, setActiveTypeOptions] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [currentErrors, setCurrentErrors] = useState({});
  const userCompany = useUserCompany();
  const user = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const [formData, setFormData] = useState(
    editMode && currentValues?.dynamicHeaderRequestDM
      ? {
          tdhTransporter:
            currentValues.dynamicHeaderRequestDM.tdhTransporter || "",
          tdhStatus: currentValues.dynamicHeaderRequestDM.tdhStatus,
          tdhActionDate: currentValues.dynamicHeaderRequestDM.tdhActionDate
            ? formatToDateOnlyFromJsonDate(
                currentValues.dynamicHeaderRequestDM.tdhActionDate,
              )
            : "",
          tdhNextDate: currentValues.dynamicHeaderRequestDM.tdhNextDate
            ? formatToDateOnlyFromJsonDate(
                currentValues.dynamicHeaderRequestDM.tdhNextDate,
              )
            : "",
          tdhRefId: currentValues.dynamicHeaderRequestDM.tdhRefId || "",
          tdhStatus: currentValues.dynamicHeaderRequestDM.tdhStatus || 2,
          tdhCompany:
            currentValues.dynamicHeaderRequestDM.tdhCompany ||
            userCompany.comId,
          tdhCategory: currentValues.dynamicHeaderRequestDM.tdhCategory || 2,
          tdhActive: currentValues.dynamicHeaderRequestDM.tdhActive || 1,
          tdhInspectionType:
            currentValues.dynamicHeaderRequestDM.tdhInspectionType || 3,
          tdhTemplate: currentValues.dynamicHeaderRequestDM.tdhTemplate || 129,
          tdhReferance:
            currentValues.dynamicHeaderRequestDM.tdhReferance || "JBIU",
          thdDepreciation:
            currentValues.dynamicHeaderRequestDM.thdDepreciation || 2,
          tdhActionTaken:
            currentValues.dynamicHeaderRequestDM.tdhActionTaken || 2,
          tdhExcId: currentValues.dynamicHeaderRequestDM.tdhExcId || -1,
          tdhExcRate: currentValues.dynamicHeaderRequestDM.tdhExcRate || 1,
          tdhId: currentValues.dynamicHeaderRequestDM.tdhId || null,
        }
      : {
          tdhTransporter: "",
          tdhActionDate: "",
          tdhNextDate: "",
          tdhRefId: "",
          tdhStatus: 1,
          tdhCompany: userCompany.comId,
          tdhCategory: 2,
          tdhActive: 1,
          tdhInspectionType: 3,
          tdhTemplate: 129,
          tdhReferance: "JBIU",
          thdDepreciation: 2,
          tdhActionTaken: 2,
          tdhActionTaken: 2,
          tdhExcId: -1,
          tdhExcRate: 1,
          createdBy: user.username,
        },
  );

  const [selectedJobs, setSelectedJobs] = useState({});
  const [vehicleReset, setVehicleReset] = useState(false);

  useEffect(() => {
    if (editMode && formData.tdhTransporter) {
      setFormData((prevState) => ({
        ...prevState,
        tdhRefId: null,
      }));
      setVehicleReset(true);
      setTimeout(() => setVehicleReset(false), 100);
    }
  }, [formData.tdhTransporter, editMode]);
  useEffect(() => {
    setSelectedJobs({});
  }, [
    formData.tdhTransporter,
    dateType,
    formData.tdhActionDate,
    formData.tdhNextDate,
  ]);

  useEffect(() => {
    if (!editMode || !currentValues?.dynamicHeaderRefRequestList?.length)
      return;

    (async () => {
      const jobOptions = await searchInvoiceJobs({
        request,
        searchText: "",
      });

      const jobs = {};

      currentValues.dynamicHeaderRefRequestList.forEach((item) => {
        const match = jobOptions.find((opt) => opt.key === item.dyjOpeRefId);

        jobs[item.dyjOpeRefId] = match ? match.title : item.dyjOpeRefId;
      });

      setSelectedJobs(jobs);
    })();
  }, [editMode, currentValues]);

  const [tdhCode, setTdhCode] = useState(
    editMode && currentValues?.dynamicHeaderRequestDM?.tdhCode
      ? currentValues.dynamicHeaderRequestDM.tdhCode
      : "",
  );
  const [dynamicHeaderRefResponses, setDynamicHeaderRefResponses] = useState(
    editMode && currentValues.dynamicHeaderRefResponses
      ? currentValues.dynamicHeaderRefResponses
      : [],
  );

  const errorState = useSelector((state) => state.error.supplierInvoiceErrors);
  const supplierInvoiceErrors = useSelector(
    (state) => state.error.supplierInvoiceErrors.supplierInvoiceErrors,
  );

  const { firstViableTab, lastViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Fleet,
    section: FORMS.TRANSPORTER_INVOICE,
  });

  const { next, prev } = useNextAndPreviousAuthority({
    sectionKey: "agreement",
    minTab: 1,
    maxTab: 2,
    module: MODULES.Fleet,
    section: FORMS.TRANSPORTER_INVOICE,
    currentTab: tab,
    authenticated: true,
  });

  useEffect(() => {
    setCurrentErrors(supplierInvoiceErrors);
  }, [supplierInvoiceErrors]);

  useEffect(() => {
    (async () => {
      const {
        date_types: dateTypeData,
        status = [],
        active = [],
        doc_type: docTypeOpt = [],
        "file_name#15": fileNameOpt = [],
      } = await getBulkDropdownData([
        { key: "date_types" },
        { key: "status" },
        { key: "active" },
        { key: "doc_type" },
        { key: "file_name", group: "15" },
      ]);

      setDateTypeOpt(dateTypeData);
      setStatusTypeOptions(status);
      setActiveTypeOptions(active);
      setDocumentTypeOptions(docTypeOpt);
      setFileNameOptions(fileNameOpt);
    })();
  }, []);

  useEffect(() => {
    if (
      !formData.tdhTransporter ||
      !formData.tdhActionDate ||
      !formData.tdhNextDate
    )
      return;
    (async () => {
      const getInvoiceJobs = await searchInvoiceJobs(request);
    })();
  }, [
    formData.tdhTransporter,
    dateType,
    formData.tdhActionDate,
    formData.tdhNextDate,
  ]);

  const request = {
    transporter: formData.tdhTransporter,
    dateType: dateType ? dateType : null,
    fromDate: formData.tdhActionDate,
    toDate: formData.tdhNextDate,
  };

  const resetForm = () => {
    setFormData({
      tdhTransporter: "",
      tdhActionDate: "",
      tdhNextDate: "",
      tdhRefId: "",
    });
    setSelectedJobs([]);
  };

  const validateDocuments = () => {
    const docState = docRef.current?.getData?.();
    if (!docState) return false;

    if (Array.isArray(docState)) {
      return docState.length > 0;
    }

    const created = docState.created || [];
    const modified = docState.modified || [];

    const totalDocuments = created.length + modified.length;

    if (editMode && totalDocuments === 0) {
      return documents && documents.length > 0;
    }

    return totalDocuments > 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateDocuments()) {
      toast.error("Please upload at least one document.", {
        autoClose: 5000,
        containerId: "Main",
      });
      setTab(2);
      return;
    }
    setIsSubmitLoading(true);
    dispatch(errorActions.clearSupplierInvoiceError());
    const requestData = {
      tdhTransporter: formData.tdhTransporter,
      tdhActionDate: formData.tdhActionDate,
      tdhNextDate: formData.tdhNextDate,
      dateType,
      tdhRefId: formData.tdhRefId,
      selectedJobs,
    };
    const supplierInvoiceErrors = supplierInvoiceValidation(requestData);
    if (Object.entries(supplierInvoiceErrors).length > 0) {
      dispatch(
        errorActions.validateSupplierInvoice({
          supplierInvoiceData: requestData,
        }),
      );
      setIsSubmitLoading(false);
      toast.error("There was a error adding Supplier Invoice", {
        autoClose: 5000,
        containerId: "Main",
      });

      return;
    } else {
      if (!editMode) {
        try {
          setIsSubmitLoading(true);
          const data = {
            dynamicHeaderRequestDM: {
              tdhTransporter: formData.tdhTransporter,
              tdhActionDate: formData.tdhActionDate,
              tdhNextDate: formData.tdhNextDate,
              tdhRefId: formData.tdhRefId,
              tdhStatus: 2,
              tdhCompany: userCompany.comId,
              tdhCategory: 2,
              tdhActive: 1,
              tdhInspectionType: 3,
              tdhTemplate: 129,
              tdhReferance: "JBIU",
              thdDepreciation: 2,
              tdhActionTaken: 2,
              tdhExcId: -1,
              tdhExcRate: 1,
              createdBy: user.username,
            },
            dynamicHeaderRefRequestList: Object.keys(selectedJobs).map(
              (jobKey) => ({
                dyjId: null,
                dyjCode: null,
                dyjReferance: null,
                dyjCompany: 1,
                dyjDyhId: null,
                dyjOpeType: 1,
                dyjOpeRefId: parseInt(jobKey, 10),
                dyjStatus: 2,
                dyjActive: 1,
                createdBy: user.username,
                lastModifiedBy: null,
              }),
            ),
          };
          const response = await saveDocumentManagement(data);

          if (response?.status === 200) {
            const documents = docRef.current.getData();

            let hasUploadErrors = false;
            if (documents.length > 0) {
              for (let doc of documents) {
                const { file, ...rest } = doc;
                const formData = new FormData();
                formData.append("multipartFile", doc.file);
                formData.append(
                  "documentRequest",
                  JSON.stringify({
                    ...rest,
                    docReference: response.data.tdhId,
                  }),
                );
                formData.append("isImage", rest.docCategory === 1);
                const res = await addAndUpload(formData);
                console.log("save supplier invoice upload", formData);
                if (res && res?.responseCode === "2040") {
                  toast.success(res?.message, {
                    autoClose: 5000,
                    containerId: "Main",
                  });
                } else {
                  hasUploadErrors = true;
                  docRef.current.markUploadFailed(doc.id ?? doc.fileName);
                  toast.error(
                    res?.message || `Error adding document ${doc.docName}`,
                    {
                      autoClose: 5000,
                      containerId: "Main",
                    },
                  );
                }
              }
            }

            toast.success(response.data.tdhCode + " Created Successfully..", {
              autoClose: 5000,
              containerId: "Main",
            });
            setIsSubmitLoading(false);

            if (hasUploadErrors) {
              setIsSubmitLoading(false);
              return;
            }

            resetForm();
            handleDrawerClose();
          }
        } catch (error) {
          console.error(error);
          toast.error("Something went wrong. Please try again.", {
            autoClose: 5000,
            containerId: "Main",
          });
        } finally {
          setIsSubmitLoading(false);
        }
      } else {
        try {
          setIsSubmitLoading(true);
          const data = {
            dynamicHeaderRequestDM: {
              tdhTransporter: formData.tdhTransporter,
              tdhActionDate: formData.tdhActionDate,
              tdhNextDate: formData.tdhNextDate,
              tdhRefId: formData.tdhRefId,
              tdhStatus: 2,
              tdhCompany: userCompany.comId,
              tdhCategory: 2,
              tdhActive: 1,
              tdhInspectionType: 3,
              tdhTemplate: 129,
              tdhReferance: "JBIU",
              thdDepreciation: 2,
              tdhActionTaken: 2,
              tdhExcId: -1,
              tdhExcRate: 1,
              createdBy: user.username,
            },
            dynamicHeaderRefRequestList: Object.keys(selectedJobs).map(
              (jobKey) => {
                const existing = dynamicHeaderRefResponses.find(
                  (ref) => ref.dyjOpeRefId === parseInt(jobKey, 10),
                );
                return {
                  dyjId: existing ? existing.dyjId : null,
                  dyjCode: existing ? existing.dyjCode : null,
                  dyjReferance: existing ? existing.dyjReferance : null,
                  dyjCompany: 1,
                  dyjDyhId: existing ? existing.dyjDyhId : null,
                  dyjOpeType: 1,
                  dyjOpeRefId: parseInt(jobKey, 10),
                  dyjStatus: 2,
                  dyjActive: 1,
                  createdBy: existing ? existing.createdBy : user.username,
                  lastModifiedBy: user.username,
                };
              },
            ),
          };
          const response = await updateDocumentManagement(formData.tdhId, data);
          if (response?.status === 200) {
            const documents = docRef.current.getData();
            let hasUploadErrors = false;
            for (let doc of documents.created) {
              const { file, ...rest } = doc;
              const formData = new FormData();
              formData.append("multipartFile", doc.file);
              formData.append("documentRequest", JSON.stringify(rest));
              formData.append("isImage", rest.docCategory === 1);
              const res = await addAndUpload(formData);
              if (res && res?.responseCode === "2040") {
                toast.success(res?.message, {
                  autoClose: 5000,
                  containerId: "Main",
                });
              } else {
                hasUploadErrors = true;
                docRef.current.markUploadFailed(doc.id ?? doc.fileName);
                toast.error(
                  res?.message || `Error adding document ${doc.docName}`,
                  {
                    autoClose: 5000,
                    containerId: "Main",
                  },
                );
              }
            }

            for (let doc of documents.modified) {
              const { file, ...rest } = doc;
              const formData = new FormData();
              formData.append("multipartFile", doc.file);
              formData.append("documentRequest", JSON.stringify(rest));
              formData.append("isImage", rest.docCategory === 1);
              const res = await updateAndUpload(formData);
              if (res && res?.responseCode === "2040") {
                toast.success(res?.message, {
                  autoClose: 5000,
                  containerId: "Main",
                });
              } else {
                hasUploadErrors = true;
                docRef.current.markUploadFailed(doc.id ?? doc.fileName);
                toast.error(
                  res?.message || `Error updating document ${doc.docName}`,
                  {
                    autoClose: 5000,
                    containerId: "Main",
                  },
                );
              }
            }

            if (documents?.deleted.length > 0) {
              await deleteDocumentList({
                docIdList: documents?.deleted,
              });
              toast.success("Documents deleted successfully!", {
                autoClose: 5000,
                containerId: "Main",
              });
            }

            toast.success(tdhCode + " Updated Successfully..", {
              autoClose: 5000,
              containerId: "Main",
            });

            if (hasUploadErrors) {
              setIsSubmitLoading(false);
              return;
            }
            resetForm();
            handleDrawerClose();
          }
        } catch (error) {
          console.error(error);
          toast.error("Something went wrong. Please try again.", {
            autoClose: 5000,
            containerId: "Main",
          });
        } finally {
          setIsSubmitLoading(false);
        }
      }
    }
  };

  const nextHandler = () => {
    switch (tab) {
      case 1: {
        const requestData = {
          tdhTransporter: formData.tdhTransporter,
          tdhActionDate: formData.tdhActionDate,
          tdhNextDate: formData.tdhNextDate,
          dateType,
          tdhRefId: formData.tdhRefId,
          selectedJobs,
        };

        const supplierInvoiceErrors = supplierInvoiceValidation(requestData);
        if (Object.keys(supplierInvoiceErrors).length > 0) {
          dispatch(
            errorActions.addSupplierInvoiceErrorObject({
              form: "supplierInvoiceErrors",
              errors: supplierInvoiceErrors,
            }),
          );
          toast.error("Please fill in all mandatory fields.", {
            autoClose: 5000,
            containerId: "Main",
          });
          return;
        } else {
          dispatch(errorActions.clearSupplierInvoiceError());
        }
        if (
          formData.tdhNextDate &&
          new Date(formData.tdhNextDate) < new Date(formData.tdhActionDate)
        ) {
          dispatch(
            errorActions.addSupplierInvoiceError({
              form: "supplierInvoiceErrors",
              key: "tdhActionDate",
              value: "End date cannot be before start date.",
            }),
          );
          toast.error("End date cannot be before start date.", {
            autoClose: 5000,
            containerId: "Main",
          });
          return;
        } else {
          dispatch(errorActions.clearSupplierInvoiceError());
        }
        break;
      }
      default:
    }

    setTab(next());
  };

  return (
    <div>
      <div style={{ width: "60vw" }}>
        <Card className="stakeholder-card-container">
          <CardContent>
            <div className="ui top attached tabular menu">
              <Tab
                Icon={FaFileInvoice}
                onClick={() => {
                  setTab(1);
                }}
                active={tab === 1}
                label="Transporter Invoice Details"
                form={FORMS.TRANSPORTER_INVOICE.INVOICE_INFO.form}
                module={MODULES.Fleet}
                authenticated={true}
                showMandatory={true}
                isMandatory={true}
                errors={
                  Object.keys(errorState.supplierInvoiceErrors).length > 0
                }
              />
              <Tab
                Icon={File}
                onClick={() => {
                  setTab(2);
                }}
                active={tab === 2}
                label="Documents"
                form={FORMS.TRANSPORTER_INVOICE.DOCUMENT.form}
                authenticated={true}
                showMandatory={true}
                isMandatory={true}
                module={MODULES.Fleet}
              />
            </div>
            <div
              className="ui bottom attached active tab segment"
              style={{ display: tab === 1 ? "block" : "none" }}
            >
              <form className="ui form">
                <div className="ui segment">
                  <h4 className="ui dividing header">
                    Transporter Invoice Details
                  </h4>
                  <div className="two fields">
                    <SearchDropdown
                      clearable={true}
                      api={getOtherRefSearchDropdown}
                      editMode={editMode}
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      required={true}
                      value={formData.tdhTransporter}
                      field="tdh_transporter"
                      onResultSelect={(data) =>
                        setFormData((prevState) => ({
                          ...prevState,
                          tdhTransporter: data,
                        }))
                      }
                      apiDependency={{
                        type: "stakeholder_type",
                        value: "transporter_all",
                      }}
                      onClear={() => {
                        setFormData((prevState) => ({
                          ...prevState,
                          tdhTransporter: null,
                          tdhRefId: null,
                        }));
                        setVehicleReset(true);
                        setTimeout(() => setVehicleReset(false), 100);
                      }}
                      fieldInfo={{
                        tableName: "masterdata.tms_m_stakeholder",
                        primaryKey: "stk_id",
                        fieldName: "stk_name",
                        id: formData.tdhTransporter?.toString(),
                      }}
                      error={currentErrors.tdhTransporter}
                      resetError={() => {
                        setCurrentErrors((prevState) => {
                          const { tdhTransporter: _, ...rest } = prevState;
                          return rest;
                        });
                      }}
                      label="Transporter"
                    />
                    <Dropdown
                      label="Date Type"
                      options={dateTypeOpt}
                      placeholder="Date Type"
                      error={currentErrors.dateType}
                      style={{ height: "20px" }}
                      value={dateType}
                      onChange={(e, data) => {
                        setDateType(data.value);
                      }}
                      resetError={() => {
                        setCurrentErrors((prevState) => {
                          const { dateType: _, ...rest } = prevState;
                          return rest;
                        });
                      }}
                    />
                  </div>
                  <div className="two fields">
                    <Input
                      type="date"
                      label="From Date"
                      placeholder="From Date"
                      editMode={editMode}
                      name="tdhActionDate"
                      value={formData.tdhActionDate}
                      required={true}
                      field="tdh_action_date"
                      error={currentErrors.tdhActionDate}
                      onChange={(e) => {
                        setFormData((prevState) => ({
                          ...prevState,
                          tdhActionDate: e.target.value,
                        }));
                      }}
                      resetError={() => {
                        setCurrentErrors((prevState) => {
                          const { tdhActionDate: _, ...rest } = prevState;
                          return rest;
                        });
                      }}
                    />

                    <Input
                      type="date"
                      label="To Date"
                      placeholder="To Date"
                      editMode={editMode}
                      value={formData.tdhNextDate}
                      required={true}
                      field="tdh_next_date"
                      onChange={(e) => {
                        setFormData((prevState) => ({
                          ...prevState,
                          tdhNextDate: e.target.value,
                        }));
                      }}
                      error={currentErrors.tdhNextDate}
                      resetError={() => {
                        setCurrentErrors((prevState) => {
                          const { tdhNextDate: _, ...rest } = prevState;
                          return rest;
                        });
                      }}
                    />
                  </div>
                  <div className="field">
                    <SearchDropdown
                      editMode={editMode}
                      multiple={true}
                      returnFullObject={true}
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      occupySpace={false}
                      multiValueRemoveHandler={(key) => {
                        setSelectedJobs((prev) => {
                          const { [key]: _, ...rest } = prev;
                          return rest;
                        });
                      }}
                      onClear={() => setSelectedJobs([])}
                      onResultSelect={(data) => {
                        setSelectedJobs((prev) => ({
                          ...prev,
                          [data.key]: data.title,
                        }));
                      }}
                      api={searchInvoiceJobs}
                      apiDependency={{
                        request: request,
                      }}
                      multiValueTwoWayBinding={true}
                      multiValues={selectedJobs}
                      label="Jobs"
                    />
                  </div>
                  <div className="field">
                    <SearchDropdown
                      reset={vehicleReset}
                      setReset={setVehicleReset}
                      editMode={editMode}
                      clearable={true}
                      api={vehicleAssignmentSearch}
                      field="tdh_ref_id"
                      apiDependency={{
                        lTransporter: formData.tdhTransporter,
                      }}
                      fieldInfo={{
                        tableName: "masterdata.tms_m_vehicle_details",
                        primaryKey: "veh_id",
                        fieldName: "veh_vehicleno",
                        id: formData.tdhRefId,
                      }}
                      label="Vehicle"
                      value={formData.tdhRefId}
                      onResultSelect={(data) =>
                        setFormData((prevState) => ({
                          ...prevState,
                          tdhRefId: data,
                        }))
                      }
                      error={currentErrors.tdhRefId}
                      resetError={() => {
                        setCurrentErrors((prevState) => {
                          const { tdhRefId: _, ...rest } = prevState;
                          return rest;
                        });
                      }}
                      onClear={() => {
                        setFormData((prevState) => ({
                          ...prevState,
                          tdhRefId: null,
                        }));
                      }}
                    />
                  </div>
                </div>
              </form>
            </div>
            <div
              className="ui bottom attached active tab segment"
              style={{ display: tab === 2 ? "block" : "none" }}
            >
              <DocumentUpload
                opeType={16}
                ref={docRef}
                files={files}
                setFiles={setFiles}
                module={MODULES.Fleet}
                reference={tdhId}
                dropdown={{
                  documentTypeOptions,
                  statusOptions: statusTypeOptions,
                  fileNameOptions,
                  activeOptions: activeTypeOptions,
                }}
                isLoading={isLoading}
                isOnTheModal={true}
                editMode={editMode}
                currentValues={editMode ? documents : null}
              />
            </div>
          </CardContent>
        </Card>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            marginTop: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {tab > firstViableTab && (
              <Button
                template="back"
                tab={tab - 1}
                module={MODULES.Fleet}
                section={FORMS.TRANSPORTER_INVOICE}
                authenticated={true}
                onClick={() => setTab(prev())}
              />
            )}
            {tab < lastViableTab && (
              <Button
                template="next"
                tab={tab + 1}
                module={MODULES.Fleet}
                section={FORMS.TRANSPORTER_INVOICE}
                authenticated={true}
                onClick={nextHandler}
              />
            )}
            {editMode ? (
              <Button
                type="submit"
                template="create"
                isLoading={isSubmitLoading}
                create={!editMode}
                form={FORMS.TRANSPORTER_INVOICE.INVOICE_INFO.form}
                module={MODULES.Fleet}
                section={FORMS.TRANSPORTER_INVOICE}
                authenticated={true}
                editMode={editMode}
                onClick={handleSubmit}
              />
            ) : tab === lastViableTab && !isLoading ? (
              <Button
                type="submit"
                template="create"
                isLoading={isSubmitLoading}
                create={!editMode}
                form={FORMS.TRANSPORTER_INVOICE.INVOICE_INFO.form}
                module={MODULES.Fleet}
                section={FORMS.TRANSPORTER_INVOICE}
                authenticated={true}
                editMode={editMode}
                onClick={handleSubmit}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransporterInvoiceAdd;
